import FormType from './FormType'
import IAnswer from './IAnswer'
import IForm from './IForm'
import IQuestion from './IQuestion'

export interface IQuestionAnswer {
  question: IQuestion
  answer: IAnswer | null
}

export interface IQuestionsData {
  [patientId: string]: {
    [formType: string]: {
      currentFormId: IForm['id']
      attempt: number
      gainedAnswers: IGainedAnswers[]
      [formId: string]:
        | {
            activeAnswer: number | null
            answers: IQuestionAnswer[]
          }
        | any
    }
  }
}

export enum FormId {
  '3_4' = '3_4',
  '4_5' = '4_5',
  '5_6' = '5_6',
  '6_7' = '6_7',
  '7_8' = '7_8',
  empty = ''
}

export enum AfterFailFormId {
  empty = '',
  '3_4' = '',
  '4_5' = '3_4',
  '5_6' = '4_5',
  '6_7' = '5_6',
  '7_8' = '5_6'
}

export interface ISetAnswersParams {
  formType: FormType
  formTypeData: {
    currentFormId: IForm['id']
    attempt: number
    gainedAnswers: IGainedAnswers[]
    [formId: string]:
      | {
          activeAnswer: number | null
          answers: IQuestionAnswer[]
        }
      | any
  }
}

export interface ISetAnswersReduserParams extends ISetAnswersParams {
  patientId: string
}

export interface IGainedAnswers {
  form: IForm
  answers: IQuestionAnswer[]
}

export default IQuestionAnswer



// WEBPACK FOOTER //
// ./src/data/questionnaires/IQuestionAnswer.ts